import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { getRoleRank } from '../constants/roles';
import { getBestRole } from '../utils/authUtils';
import useIsMobile from './useIsMobile';

/**
 * Single source of truth for what the current user may do on this device.
 *  - isViewOnly:      role rank > 3. Blocks every write (status change, dismiss, reset, edit...).
 *  - canManageAgents: create / edit / copy / delete / reorder agents. Role-gated AND desktop-only,
 *                     because the mobile experience is a monitor (no agent management).
 * Operational actions (dismiss, status change, reset) follow isViewOnly only, so they stay on mobile.
 */
const useCapabilities = () => {
	const { state } = useContext(AuthContext);
	const isMobile = useIsMobile();
	const role = getBestRole(state?.user);
	const isViewOnly = getRoleRank(role) > 3;

	return {
		role,
		isMobile,
		isViewOnly,
		canManageAgents: !isViewOnly && !isMobile
	};
};

export default useCapabilities;
